import React from 'react'
import { StyleSheet, Text, View } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  bulletPoint: {
    width: 10,
    marginRight: 4,
    marginLeft: 4,
    fontSize: 16,
  },
  item: {
    flexDirection: 'row',
  },
  itemContent: {
    flex: 1,
    flexDirection: "column",
  },
})

const ListItem = ({ children }) => (
  <View style={styles.item}>
    <Text style={styles.bulletPoint}>•</Text>
    <Text style={styles.itemContent}>{children}</Text>
  </View>
)

export default ListItem
